import { get } from 'lodash';

const EDITORS_CHOICE_VEHICLE_MAP = {
  lincoln: {
    navigator: true,
  },
  mazda: {
    'mx-5-miata': true,
  },
  honda: {
    accord: true,
    'cr-v': true,
  },
  ram: {
    '1500': true,
  },
  hyundai: {
    'kona-electric': true,
  },
  'mercedes-benz': {
    'a-class': true,
  },
};

export function isEditorsChoice({ make, model, year }) {
  return parseInt(year, 10) === 2019 && get(EDITORS_CHOICE_VEHICLE_MAP, `[${make}][${model}]`);
}
